// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__JaKIU","label":"CategoryService_label__F07J1","location":"CategoryService_location__3OcDh"};